<app-card [titleKey]="translationKey + 'cardTitle'">
  <div class="row flex-between-center">
    <div class="col-auto my-2">
      <labeled-content [label]="'general.natureOfLoan'">
        <label class="data-labels">{{
          projectDetails().loanCoverage
            | baseEnumItemById
              : "generic.projectLoanCoverage"
              : genericProjectStore.projectLoanCoverageEntities()
            | translate
        }}</label>
      </labeled-content>
    </div>
    <!-- <label class="data-labels">{{
      projectDetails().loanUsage
        | baseEnumItemById
          : "generic.projectLoanUsage"
          : genericProjectStore.projectLoanUsageEntities()
        | translate
    }}</label> -->
    <div class="col-auto my-2">
      <labeled-content [label]="'general.runtime'">
        <label class="data-labels">{{
          projectDetails().loanTerm
            | baseEnumItemById
              : "generic.projectLoanTerm"
              : genericProjectStore.projectLoanTermEntities()
            | translate
        }}</label>
      </labeled-content>
    </div>
    <div class="col-auto my-2">
      <labeled-content [label]="'general.condition'">
        <label class="data-labels">{{ projectDetails().conditions }}</label>
      </labeled-content>
    </div>
  </div>

  <hr />
  <div>
    <label class="sub-header">{{
      "general.applicableInterestRate" | translate
    }}</label>
  </div>
  <app-table [columns]="columns" [rowsData]="rowsData()" />

  <div>
    <labeled-content [label]="'general.condition'">
      <label class="data-labels">{{ 'general.no' | translate }}</label>
    </labeled-content>
  </div>

  <hr class="strong-border" />

  <div>
    <label class="sub-header">{{
      translationKey + "subSectionOne.sectionTitle" | translate
    }}</label>
  </div>
  <app-info-label [label]="translationKey + 'subSectionOne.sectionInfo'" />

  <hr class="strong-border" />

  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionOne.sectionTitle" | translate
    }}</label>
  </div>

  <div>
    <labeled-content [label]="'general.additionalAssurance'">
      <span class="data-labels">{{
        (projectDetails().isInvestmentSecuredByThirdParty ? "general.yes" : "general.no")
          | translate
      }}</span>
    </labeled-content>
  </div>

  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionOne.collatoralProvidersInfo"
        | translate
    }}</label>
  </div>
  <!-- <app-special-entity-contacts /> -->

  <div>
    <label class="sub-section-header my-2">{{
      translationKey + "subSectionOne.subsectionOne.guarantorInfo" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{ projectDetails().informationOnNatureAndConditionsOfGuarantee }}
    </p>
  </div>
  <hr class="strong-border" />

  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionTwo.sectionTitle" | translate
    }}</label>
  </div>

  <div>
    <labeled-content
      [label]="
        translationKey + 'subSectionOne.subsectionTwo.additionalCommitment'
      "
    >
      <span class="data-labels">{{
        (projectDetails().isRepurchaseCommitment ? "general.yes" : "general.no")
          | translate
      }}</span>
    </labeled-content>
  </div>

  <hr />

  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionTwo.assurerInfo" | translate
    }}</label>
  </div>
  @for (person of projectDetails().personsSectiopG; track $index) {
    <app-name-connection-form [person]="person" />
  }
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionTwo.assurerInfo" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails().informationOnNatureAndConditionsOfSurety
      }}
    </p>
  </div>

  <hr class="strong-border" />

  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionThree.sectionTitle" | translate
    }}</label>
  </div>

  <div>
    <labeled-content
      [label]="
        translationKey + 'subSectionOne.subsectionThree.additionalGuarantee'
      "
    >
      <span class="data-labels">{{
        (projectDetails().isGuarantorLegalEntity ? "general.yes" : "general.no")
          | translate
      }}</span>
    </labeled-content>
  </div>

  <hr />

  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionThree.guarantorsNameContact"
        | translate
    }}</label>
  </div>
  <!-- <app-special-entity-contacts /> -->
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "subSectionOne.subsectionThree.guaranteeInfo" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{ projectDetails().informationOnNatureAndConditionsOfWarranty }}
    </p>
  </div>

  <hr class="strong-border" />

  <div>
    <label class="sub-header">{{
      translationKey + "subsectionTwo.sectionTitle" | translate
    }}</label>
  </div>
  <div class="row flex-between-center border my-2">
    <div class="col-3 my-2">
      <labeled-content
        [label]="translationKey + 'subsectionTwo.capitalRepayment'"
      >
        <label class="data-labels">{{
          projectDetails().loanTypeCapitalPaymentFrequency
            | baseEnumItemById
              : "generic.loanTypePaymentFrequency"
              : genericProjectStore.loanTypePaymentFrequencyEntities()
            | translate
        }}</label>
      </labeled-content>
    </div>
    <div class="col-8 my-2">
      <labeled-content
        [label]="translationKey + 'subsectionTwo.interestRepayment'"
      >
        <label class="data-labels">{{
          projectDetails().loanTypeInterestPaymentFrequency
            | baseEnumItemById
              : "generic.loanTypePaymentFrequency"
              : genericProjectStore.loanTypePaymentFrequencyEntities()
            | translate
        }}</label>
      </labeled-content>
    </div>
    <div class="col-8 my-2">
      <labeled-content
        [label]="
          translationKey + 'subsectionTwo.notCompletedProjectWithinFiveYears'
        "
      >
        <label class="data-labels">—</label>
      </labeled-content>
    </div>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "subsectionTwo.notCompletedLoanData" | translate
    }}</label>
  </div>
  <app-not-completed-loan-display
    [assets]="projectDetails().financialAssetsSectionG ?? []"
  />
  <hr />

  <div>
    <label class="sub-section-header">{{
      translationKey + "subsectionTwo.notCompletedInfo" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{ projectDetails().informationOnLoanAndNonCompliance }}
    </p>
  </div>

  <hr class="strong-border" />

  <div>
    <label class="sub-header">{{
      translationKey + "subsectionThree.sectionTitle" | translate
    }}</label>
  </div>
  <div>
    <label class="sub-section-header">{{
      translationKey + "subsectionThree.loanInfo" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{ projectDetails().informationOnLoanAndItsManagement }}
    </p>
  </div>
</app-card>

<ng-template #percentColumnTemplateRef let-data>
  @if (data === undefined) {
    <span> - </span>
  } @else {
    <span>{{ data.yearlyInterest + " %" }}</span>
  }
</ng-template>
